import { useMemo } from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useBasicDataQuery } from "../../../services/basicData/basicData";
import { useGetHouseContractsQuery } from "../../../services/makkahGroups";
import {
  useUpdateHousingContractMutation,
  useHousingDetailsQuery,
} from "../../../services/housing";
import { Spinner } from "react-bootstrap";
import { UpdateHousingContractForm } from "./UpdateHousingContractForm";

export const UpdateHousingContract = () => {
  const { t } = useTranslation();

  // Fetch house details
  const {
    data: houseDetailsRes,
    isLoading: isHouseLoading,
    isFetching: isHouseFetching,
  } = useHousingDetailsQuery();
  const houseData = houseDetailsRes?.data?.data;
  const house = houseData?.house || {};
  const isLoadingHouseDetails = isHouseLoading || isHouseFetching;

  // Fetch basic data
  const { data: basicDataRes } = useBasicDataQuery();
  const basicData = basicDataRes?.data?.data || {};

  // Fetch housing contracts
  const {
    data: contractsRes,
    isLoading: isContractsLoading,
    isFetching: isContractsFetching,
  } = useGetHouseContractsQuery();
  const contracts = contractsRes?.data?.data || [];
  const isContractsLoadingState = isContractsLoading || isContractsFetching;

  // Mutation for updating
  const { mutate: updateHousingContract, isPending } =
    useUpdateHousingContractMutation();



  const handleFormSubmit = (data) => {
    updateHousingContract(data);
  };

  // Show loading spinner while fetching house details
  if (isLoadingHouseDetails) {
    return (
      <div>
        <PageHeader title={t("تعديل تفاصيل مسكن")} sticky={false} />
        <Container fluid>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "300px" }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">{t("LOADING")}</span>
            </Spinner>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title={t("تعديل تفاصيل مسكن")} sticky={false} />
      <Container fluid>
        <UpdateHousingContractForm
          defaultValues={house}
          basicData={basicData}
          contracts={contracts}
          isContractsLoadingState={isContractsLoadingState}
          onSubmit={handleFormSubmit}
          isPending={isPending}
        />
      </Container>
    </div>
  );
};

